import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPConjoinedPlanets } from './KPConjoinedPlanets';
import { KPConjoinedPlanetsTable } from './KPConjoinedPlanetsTable';

export function KPConjoinedPlanetsChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[8]} className="m-0 p-0 ">
              <Row id="conjoinedPlanetsChart" className="m-0 p-0">
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPConjoinedPlanets userData={userData}/>
                  </Col>
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPConjoinedPlanetsTable userData={userData}/>
                  </Col>
              </Row>
          </Collapse>
      }
    </>  
  );
}
